import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

export default function Blog() {
  const { t } = useTranslation();

  const blogPosts = [
    {
      title: t('blog_post_1_title'),
      excerpt: t('blog_post_1_excerpt'),
      date: "February 1, 2026",
      category: t('product_updates'),
      author: "Zolaid Team"
    },
    {
      title: t('blog_post_2_title'),
      excerpt: t('blog_post_2_excerpt'),
      date: "January 28, 2026",
      category: t('technology'),
      author: "Zolaid Team"
    },
    {
      title: t('blog_post_3_title'),
      excerpt: t('blog_post_3_excerpt'),
      date: "January 25, 2026",
      category: t('tips_tricks'),
      author: "Zolaid Team"
    },
    {
      title: t('blog_post_4_title'),
      excerpt: t('blog_post_4_excerpt'),
      date: "January 20, 2026",
      category: t('security'),
      author: "Zolaid Team"
    },
  ];

  return (
    <MarketingLayout>
      <div className="marketing-page-content blog-page blog-page--wide">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Resources</p>
          <h1>{t('blog_title')}</h1>
          <p className="page-lead" style={{ marginBottom: 0 }}>{t('blog_subtitle')}</p>
        </header>

        <div className="blog-grid">
          {blogPosts.map((post, index) => (
            <article key={index} className="marketing-section-card blog-card">
              <div className="blog-card-meta">
                <span className="blog-card-category">{post.category}</span>
                <span className="blog-card-date">{post.date}</span>
              </div>
              <h2 className="marketing-section-title">{post.title}</h2>
              <p className="marketing-section-text mb-4">{post.excerpt}</p>
              <div className="blog-card-footer">
                <span className="blog-card-author">{t('by')} {post.author}</span>
                <Link
                  to={
                    index === 0
                      ? "/TechArticlesPage"
                      : index === 1
                        ? "/blog/ai-transforming-software-development"
                        : index === 2
                          ? "/blog/team-collaboration-with-zolaid"
                          : index === 3
                            ? "/blog/security-best-practices-ai-development"
                            : "/Blog"
                  }
                  className="contact-link"
                >
                  {t('read_more')} →
                </Link>
              </div>
            </article>
          ))}
        </div>

        <section className="marketing-section-card blog-newsletter">
          <h2 className="marketing-section-title">{t('stay_updated')}</h2>
          <p className="marketing-section-text mb-4">{t('subscribe_newsletter')}</p>
          <div className="blog-newsletter-form">
            <input type="email" placeholder={t('enter_email')} className="blog-newsletter-input" aria-label={t('enter_email')} />
            <button type="button" className="marketing-cta">{t('subscribe')}</button>
          </div>
        </section>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
